var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.contactData)?_c('contact-edit-tab',{staticClass:"mt-2 pt-75",attrs:{"contact-data":_vm.contactData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }